import React, { Fragment, useState, useEffect } from "react";
import ActionBar from "./ActionBar";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import styled from "styled-components";
import themes from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import TranscriberService from "../../../services/TranscriberService";
import { getErrorMessage } from "../../../helpers/functions";
import theme from "../../../assets/theme";
import TranscriptEditor from "../../transcripts/TranscriptEditor/index";

const TranscriptEdit = (id) => {
  const history = useLocation();
  const resolutionKind = history.search.replace("?caseType=", "");
  const breadcrumbs = [
    "Cases",
    `${_.capitalize(resolutionKind)} - ${id?.id}`,
    "Transcript",
  ];
  const [transcriptData, setTranscriptData] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const caseId = id?.id;
  const [data, setData] = useState([
    {
      id: "",
      start: "",
      end: "",
      text: "",
      speaker: "",
      confidence: "",
      modified: false,
      count: 0,
      mediaId: "",
      transcriptionFlag: "",
      speechFinal: "",
      utteranceEnd: "",
      lastTranscriptEndTime: "",
    },
  ]);
  const [meetingId, setMeetingId] = useState();
  const [discard, setDiscard] = useState([
    {
      id: "",
      start: "",
      end: "",
      text: "",
      speaker: "",
      confidence: "",
      modified: false,
      mediaId: "",
      transcriptionFlag: "",
      speechFinal: "",
      utteranceEnd: "",
      lastTranscriptEndTime: "",
    },
  ]);
  const [refreshDetails, setRefreshDetails] = useState(true);
  const [render, setRender] = useState(false);
  const [filterSpeaker, setFilterSpeaker] = useState();
  let LiveTranscription = true;
  const [isEdited, setIsEdited] = useState(false);
  const [state, setState] = useState({ state: false });
  const [checked, setChecked] = useState(false);
  const [endTranscriptFlag, setEndTranscriptFlag] = useState();
  const [meetingDetail, setMeetingDetail] = useState();

  useEffect(() => {
    async function getMeetingAccesscases(caseId) {
      try {
        const response = await TranscriberService.getMeetingAccesscases(caseId);
        if (response) {
          setMeetingDetail(response);
        }
      } catch (err) {
        console.log(err);
      }
    }
    getMeetingAccesscases(caseId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    async function getData(caseId) {
      try {
        !checked &&
          setLoader({ state: true, message: "Fetching Transcription..." });
        const res = await TranscriberService.getLiveTranscriptionData(caseId);
        const transcriptionControl =
          await TranscriberService.getTranscriptionStatus(res?.meetingId);
        if (res) {
          const lastObject =
            res?.transcriptionData?.words[
              res?.transcriptionData?.words?.length - 1
            ];

          const newObject = { ...lastObject, text: "End Of Transcript" };
          if (
            res?.transcriptionData?.words?.length > 0 &&
            transcriptionControl?.endTranscript === true
          ) {
            setData([
              ...res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el?.text ? el?.text : "",
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              }),
              newObject,
            ]);
            setDiscard([
              ...res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el?.text ? el?.text : "",
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              }),
              newObject,
            ]);
          } else {
            setData(
              res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el?.text ? el?.text : "",
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              })
            );
            setDiscard(
              res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el?.text ? el?.text : "",
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              })
            );
          }
          setMeetingId(res?.meetingId);
          setTranscriptData(res);
          setRender(true);
          setEndTranscriptFlag(transcriptionControl);
        }
      } catch (error) {
        console.log("failed");
      } finally {
        setLoader({ state: false });
        setIsEdited(false);
      }
    }
    if (refreshDetails) {
      getData(caseId);
      setRefreshDetails(false);
    }
  }, [refreshDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case `${resolutionKind}_${id?.id}`:
        navigate(`/transcriber/cases?caseType=${resolutionKind}`);
        break;
      case "cases":
        navigate(`/transcriber/cases?caseType=${resolutionKind}`);
        break;
      default:
        break;
    }
  };

  const updateLiveTranscriptionData = async (data) => {
    try {
      setLoader({ state: true, message: "Adding Transcript..." });
      /*

      let storedData = data;
      storedData.pop();
      let payload = {
        editedTranscriptionData: storedData,
        speakerNameObj: filterSpeaker,
      };
      if (state?.speakerIdendification) {
        payload = {
          editedTranscriptionData: storedData,
          speakerNameObj: filterSpeaker,
        };
      } else {
        payload = {
          editedTranscriptionData: storedData,
        };
      }
      */

      let storedData = [...data];
      let payload = {};
      if (
        LiveTranscription &&
        meetingDetail?.transcriptionModelParams?.interim_results &&
        !endTranscriptFlag?.endTranscript
      ) {
        storedData = storedData.slice(0, -2);
      } else {
        storedData.pop(); // removes last item
      }
      payload = {
        editedTranscriptionData: storedData,
        id: transcriptData?.id,
        ...(state?.speakerIdendification && { speakerNameObj: filterSpeaker }),
      };
      if (storedData?.length) {
        const res = await TranscriberService.updateLiveTranscriptionData(
          payload,
          meetingId
        );
        if (res?.updated) {
          setRefreshDetails(true);
        }
        if (res?.message) {
          enqueueSnackbar(res?.message, {
            variant: "success",
          });
        }
      } else {
        setRefreshDetails(true);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      if (message === "Error Occured While updating") {
        setRefreshDetails(true);
      } else {
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    } finally {
      setLoader({ state: false });
      setState({ state: false });
    }
  };

  const discardChanges = () => {
    setData(
      discard.map((el) => {
        return {
          id: el?.id,
          end: el?.end,
          confidence: el?.confidence,
          text: el?.text,
          start: el?.start,
          speaker: el?.speaker,
          mediaId: el?.mediaId,
          transcriptionFlag: el?.transcriptionFlag,
          speechFinal: el?.speechFinal,
          utteranceEnd: el?.utteranceEnd,
          lastTranscriptEndTime: el?.lastTranscriptEndTime,
        };
      })
    );
    setRender(true);
  };

  useEffect(() => {
    if (checked) {
      const timeInterval = setInterval(
        () => {
          setRefreshDetails(true);
        },
        transcriptData?.autoRefreshTimeInterval
          ? transcriptData?.autoRefreshTimeInterval
          : 3 * 1000
      );
      return () => clearInterval(timeInterval);
    }
  }, [checked]); // eslint-disable-line react-hooks/exhaustive-deps

  const actions = [
    {
      text: "Refresh",
      props: {
        onClick: () => setRefreshDetails(true),
      },
      hidden: data ? true : false,
    },
    {
      text: "Discard",
      props: {
        onClick: () => discardChanges(),
      },
      hidden: data ? false : true,
    },
    {
      text: "Save (alt + s)",
      props: {
        onClick: () => isEdited && updateLiveTranscriptionData(data),
      },
      disabled: transcriptData?.transcriberEditMode ? false : true,
      hidden: data ? false : true,
    },
  ];

  const autoSaveupdateTranscriptionData = async (
    data,
    state,
    filterSpeaker,
    endTranscript
  ) => {
    try {
      /*

      let storedData = data;
      storedData.pop();
      let payload = {
        editedTranscriptionData: storedData,
        speakerNameObj: filterSpeaker,
      };
      if (state?.speakerIdendification) {
        payload = {
          editedTranscriptionData: storedData,
          speakerNameObj: filterSpeaker,
        };
      } else {
        payload = {
          editedTranscriptionData: storedData,
        };
      }
      */

      let storedData = [...data];
      let payload = {};
      if (
        LiveTranscription &&
        meetingDetail?.transcriptionModelParams?.interim_results &&
        !endTranscript
      ) {
        storedData = storedData.slice(0, -2);
      } else {
        storedData.pop(); // removes last item
      }
      payload = {
        editedTranscriptionData: storedData,
        ...(state?.speakerIdendification && { speakerNameObj: filterSpeaker }),
      };
      if (storedData?.length) {
        const res = await TranscriberService.updateLiveTranscriptionData(
          payload,
          meetingId
        );
        if (res?.message) {
        }
      } else {
        setRefreshDetails(true);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      if (message === "Error Occured While updating") {
        setRefreshDetails(true);
      } else {
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    } finally {
      setState({ state: false });
    }
  };

  return (
    <Fragment>
      <ActionBar
        {...{
          breadcrumbs,
          onBreadcrumbClick,
          actions,
          transcriptData,
          LiveTranscription,
          checked,
          setChecked,
        }}
        transcriberAccess={!transcriptData?.transcriberEditMode}
      />
      <Container>
        {transcriptData?.transcriptionData ? (
          <TranscriptEditor
            {...{
              caseId,
              meetingId,
              data,
              render,
              setRender,
              setFilterSpeaker,
              LiveTranscription,
              isEdited,
              setIsEdited,
              state,
              setState,
              refreshDetails,
              setRefreshDetails,
            }}
            interimResults={
              meetingDetail?.transcriptionModelParams?.interim_results
            }
            endTranscript={endTranscriptFlag?.endTranscript}
            mediaUrl={transcriptData?.audioFileUrl}
            setData={setData}
            title={history?.state?.title}
            updateState={updateLiveTranscriptionData}
            transcriberAccess={transcriptData?.transcriberEditMode}
            autoSaveupdateTranscriptionData={autoSaveupdateTranscriptionData}
          />
        ) : (
          <StyledTableEmptyBlock>
            <h2>
              {
                "Welcome to IAMC live transcription services. Your session has either not started or your live transcript is currently being generated."
              }
            </h2>
          </StyledTableEmptyBlock>
        )}
      </Container>
    </Fragment>
  );
};

export default TranscriptEdit;

export const Container = styled.div`
  padding: 4px 43px;
  display: flex;
  flex-direction: column;
`;

export const HeadingContainer = styled.span`
  margin-bottom: 31px;
  font-family: ${themes.fonts.primaryFontSemiBold};
  font-size: ${(props) => (props.size ? props.size : "13px")};
  color: ${COLORS.BTN_GREEN};
  // text-transform: uppercase;
  cursor: pointer;
  & .topSection {
    background: ${COLORS.BOX_DARKGREEN};
  }
`;

export const StyledTableEmptyBlock = styled.div`
  position: absolute;
  top: 55%;
  left: 55%;
  transform: translate(-40%, -40%);
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    color: ${COLORS.COLOR_DARK};
    font-weight: 500;
    letter-spacing: 0.1px;
    font-size: 20px;
    margin: 0;
    text-align: center;
    font-family: ${theme.fonts.primaryFontBold};
  }
  p {
    margin: 10px auto 30px;
    font-family: ${theme.fonts.primaryFontRegular};
    color: ${COLORS.COLOR_DARK};
  }
  a {
    color: ${COLORS.BTN_GREEN};
    font-family: ${theme.fonts.primaryFontRegular};
  }
`;
